import * as React from 'react';
import { Small, Typography } from 'palette/Typography';
import { TLabelType } from '../types';
import { labelTypes } from './constants';
import './ListItemLabel.scss';

interface IListItemLabelProps {
    label?: string;
    className?: string;
    labelType?: TLabelType;
    secondaryText?: string;
    children?: React.ReactNode;
}

export function ListItemLabel({
    label,
    labelType = 'default',
    secondaryText,
    children,
}: IListItemLabelProps) {
    const labelAttributes = labelTypes[labelType];

    if (children) {
        return (
            <div className="palette-row-label">
                {children}
            </div>
        );
    }

    return (
        <div className="palette-row-label">
            <div className="palette-row-label__wrap">
                <Typography
                    className="palette-row-label__label"
                    color="regular"
                    {...labelAttributes}
                >
                    {label}
                </Typography>
                {
                    !!secondaryText && (
                        <Small color="light">
                            {secondaryText}
                        </Small>
                    )
                }
            </div>
        </div>
    );
}
